import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.widget.DOC}
  query MosaicWidgets($tenantId: ID!, $zoneId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          widgets {
            ...FragmentMosaicWidget
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.MosaicWidgetsQuery,
    ents.core.mosaic.Widget[] | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'mosaicDev',
        graphql.transformers.OUT.select(
          'widgets',
          graphql.transformers.OUT.list(fragments.widget.TRANSFORMER, {
            onNullish: 'remove',
          }),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.MosaicWidgetsQuery,
  ents.core.mosaic.Widget[],
  graphql.schema.MosaicWidgetsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
